import React from 'react';
import { MenuItem, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ChevronRightIcon } from 'assets';
import { useAppSettings, useDevices } from 'hooks';

type AudioOutputListProps = {
  forceLightTheme?: boolean;
};

export function AudioOutputList({ forceLightTheme }: AudioOutputListProps) {
  const { t } = useTranslation('providerRoom');
  const { audioOutputDevices } = useDevices();
  const { activeSinkId, setActiveSinkId } = useAppSettings();
  const activeOutputLabel = audioOutputDevices.find((device) => device.deviceId === activeSinkId)?.label;

  const isDisabled = audioOutputDevices.length <= 1;

  return (
    <>
      <Select
        fullWidth
        variant='outlined'
        disabled={isDisabled}
        IconComponent={ChevronRightIcon}
        onChange={(e) => setActiveSinkId(e.target.value as string)}
        value={!isDisabled ? activeSinkId : 'default'}
        MenuProps={
          forceLightTheme
            ? {
                PaperProps: {
                  sx: {
                    backgroundColor: '#ffffff',
                    color: '#393534',
                    '& .MuiMenuItem-root': {
                      color: '#393534',
                    },
                  },
                },
              }
            : undefined
        }
        sx={{
          ...(forceLightTheme && {
            backgroundColor: '#ffffff !important',
            color: '#393534',
            '& .MuiSelect-select': {
              backgroundColor: '#ffffff !important',
              color: '#393534 !important',
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(0, 0, 0, 0.23) !important',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(0, 0, 0, 0.23) !important',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(0, 0, 0, 0.23) !important',
            },
            '&.Mui-disabled': {
              backgroundColor: '#f3f3f3 !important',
              '& .MuiSelect-select': {
                backgroundColor: '#f3f3f3 !important',
                WebkitTextFillColor: '#626363',
              },
            },
            '& .MuiSelect-icon': {
              color: '#626363',
            },
          }),
          '& svg': {
            width: '10px',
          },
        }}
      >
        {audioOutputDevices.length > 1 ? (
          audioOutputDevices.map((device) => (
            <MenuItem value={device.deviceId} key={device.deviceId}>
              {device.label}
            </MenuItem>
          ))
        ) : (
          <MenuItem value='default'>{activeOutputLabel || t('systemDefaultAudioOutput')}</MenuItem>
        )}
      </Select>
    </>
  );
}
